import { render, staticRenderFns } from "./AppReviewMediaSectionList.vue?vue&type=template&id=2ec0559e&scoped=true"
import script from "./AppReviewMediaSectionList.vue?vue&type=script&lang=js"
export * from "./AppReviewMediaSectionList.vue?vue&type=script&lang=js"
import style0 from "./AppReviewMediaSectionList.vue?vue&type=style&index=0&id=2ec0559e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec0559e",
  null
  
)

export default component.exports